// Used for mapping between frontend and backend
export const CHATBOT_SESSION_ID_KEY: string = "chatbot_session_id";
// Used for mapping between frontend and App Insights
export const FRONTEND_SESSION_CORRELATION_ID_KEY: string =
  "frontend_session_id";

// ChatWidget
export const CHAT_HISTORY_KEY: string = "chatHistory";
export const CHAT_HISTORY_BEFORE_LOGIN_KEY: string = "chatHistoryBeforeLogin";
export const CHAT_LOGIN_HANDLING_KEY: string = "chatHandlingLogin";
export const CHAT_OPEN_STATE_KEY: string = "chatIsOpen";
export const CHAT_OPEN_BEFORE_LOGIN_KEY: string = "chatWasOpenBeforeLogin";
export const CHAT_CONTEXT_KEY: string = "chatContext";
export const EXPIRED_SESSION_MESSAGE: string =
  "Tidigare konversation har avslutats. Du får gärna fortsätta chatta med mig men jag har tyvärr ingen information om det som skrivits tidigare i denna chattruta.\n\nCookies måste vara aktiverade för att jag ska kunna se tidigare meddelanden.";
